import { ChangeDetectorRef, Component, inject, Input, ViewContainerRef } from '@angular/core';

import { collapse, trackByProp } from '@core/common-legacy';
import { I18nService } from '@core/i18n-legacy';
import type { ReferralsPortalApplication } from '@core/referrals-types';
import { ReferralContext, ReferralsPortalApplicationStatus } from '@core/referrals-types';
import type { IconName } from '@core/user-interface-legacy';
import {
  BadgeComponent,
  DialogService,
  DialogWidth,
  DividerComponent,
  HeadingComponent,
  IconComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import { ReferralsCardComponent } from '../referrals-card/referrals-card.component';
import { ReferralsDialogComponent } from '../referrals-dialog/referrals-dialog.component';

@Component({
  selector: 'rtr-referrals-list',
  templateUrl: './referrals-list.component.html',
  styleUrls: ['./referrals-list.component.less'],
  animations: [collapse],
  imports: [
    HeadingComponent,
    BadgeComponent,
    IconComponent,
    RtTooltip,
    ReferralsCardComponent,
    DividerComponent,
  ],
})
export class ReferralsListComponent {
  private readonly dialogService = inject(DialogService);
  private readonly viewContainerRef = inject(ViewContainerRef);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly i18n = inject(I18nService);
  @Input() public applications: ReferralsPortalApplication[];
  @Input() public showStatus: boolean = false;
  @Input() public title: string;
  @Input() public tooltipText: string;
  @Input() public showCounter: boolean = true;
  @Input() public collapseEnabled: boolean = true;
  @Input() public type: ReferralContext = ReferralContext.Referrals;
  @Input() public rewardsVisible: boolean = false;

  public isCollapsed: boolean = false;
  public statusTranslationsMap: Record<string, { status: string; icon: IconName }> = {
    [ReferralsPortalApplicationStatus.InReview]: {
      icon: 'clock',
      status: this.i18n.translate('rtr.referrals.statuses.referred'),
    },
    [ReferralsPortalApplicationStatus.ProcessComplete]: {
      icon: 'sidemenu-offers',
      status: this.i18n.translate('rtr.referrals.statuses.completed'),
    },
    [ReferralsPortalApplicationStatus.Claimed]: {
      icon: 'reward',
      status: this.i18n.translate('rtr.referrals.statuses.rewarded'),
    },
  };
  public trackById = trackByProp<{ id: number | string }>({ prop: 'id' });

  public collapseList(): void {
    this.isCollapsed = !this.isCollapsed;
    this.cdRef.detectChanges();
  }

  public openDialog(data: ReferralsPortalApplication): void {
    this.dialogService.openCustom(
      ReferralsDialogComponent,
      { width: DialogWidth.Small },
      { referral: data, translations: this.statusTranslationsMap, showStatus: this.showStatus },
      this.viewContainerRef,
    );
  }
}
